import React, { useEffect, useState } from "react";
import {
  Typography,
} from "design_system/src";
import { Swiper, SwiperSlide } from "swiper/react";
import Swipercore, { Navigation, Pagination, Autoplay } from "swiper";
import { TSku } from "models/inventory/interfaces/sku.interface";
import { getRecommendedSkus } from "models/inventory/controllers/sku.controller";
import VehicleItem from "./VehicleItem";
import styles from "./RecommendedVehicles.module.scss";
import RecommendedVehiclesSkeleton from "./RecommendedVehiclesSkeleton";


const LIMIT = 6;
const RecommendedVehicles: React.FC<{}> = () => {
  Swipercore.use([Navigation, Pagination, Autoplay]);
  const [skus, setSkus] = useState<TSku[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    getRecommendedSkus(LIMIT)
      .then((value) => {
        setSkus(
          value.filter(
            (sku) => (sku.minPrice ?? 0) > 0
          )
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section className={`${styles.VehiclesSection} dso_container_desktop p_t_xl`}>
      {(loading || (!loading && skus.length > 0)) && <Typography
        className="m_none m_l_md_mobile"
        weight="600"
        textColor="neutral_1000"
        scale="large"
        component="h2"
      >
        Ofertas que no puedes perder
      </Typography>}

      <div>
        {loading && (
          <RecommendedVehiclesSkeleton />
        )}
        {!loading && skus.length > 0 && (
          <div>
            <Swiper
              modules={[Pagination, Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              slidesPerView="auto"
              centeredSlides={false}
              pagination={{ clickable: true, el: ".custom-swiper-pagination" }}
            >
              {skus.map((item: TSku, idx: number) => (
                <SwiperSlide key={`slide-${idx}`}>
                  <VehicleItem sku={item} />
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="custom-swiper-pagination" />
          </div>
        )}
      </div>
    </section>
  );
};

export default RecommendedVehicles;
